<template>
  <div class="module">
    <top class="module_top" :show="true"></top>
    <div class="main">
      <div style="display: flex;align-items: center;margin: 10px 0;background-color:white">
        <ol prefix="next-" direction="hoz"  class="next-step next-step-arrow next-step-horizontal next-step-label-vertical">
          <li tabindex="0" aria-current="step" style="width: auto;" v-for="(item, index) in stepOptions" :key="index"
          class="next-step-item" :class="{'next-step-item-first':index === 0,'next-step-item-last': index === (stepOptions.length - 1),'next-step-item-process':index === activeData,'next-step-item-wait': index !== activeData}">
            <div class="next-step-item-container">
              <div :class="{'abu':index == 2}" class="next-step-item-title">{{ item.title}}</div>
            </div>
          </li>
          
        </ol>
      </div>
      <!-- <div class="img"><img src="./img/pay_top.png" alt=""></div> -->
      <div class="item">
        <div class="title">您需要支付订单</div>
        <div>
          <div class="t_header">
            <div class="item1">订单编号</div>
            <div class="item2">订单详情</div>
            <div class="item3">原订单金额</div>
            <div class="item3">实收金额</div>
            <div class="item1">订购时间</div>
          </div>
          <div class="t_body">
            <div class="item1">{{orderList.tradeNumber}}</div>
            <div class="item2"><span class="detail">{{ orderList.detailText }}</span></div>
            <div class="item3 money">{{orderList.originalPrice == null ? orderList.amount : orderList.originalPrice}}</div>
            <div class="item3 money">{{orderList.amount}}</div>
<!--            <div class="item1">{{ new Date(orderList.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</div>-->
            <div class="item1">{{ orderList.createTime }}</div>
          </div>
        </div>
        <div class="title">请选择支付类型</div>
        <div class="tabs-item">
          <el-tabs v-model="activeName" @tab-click="changeType">
            <el-tab-pane label="个人网银支付" name="first">
              <div style="margin: 20px 0">
                <el-radio v-model="personalRadio" label="1" @change="changeType">
                  <img src="./img/银联.png" alt="" class="img1">
                </el-radio>
                <el-radio v-model="personalRadio" label="2" @change="changeType">
                  <img src="./img/支付宝.png" alt="" class="img2">
                </el-radio>
                <el-radio v-model="personalRadio" label="3" @change="changeType">
                  <img src="./img/微信支付.png" alt="" class="img3">
                </el-radio>
              </div>
            </el-tab-pane>
            <el-tab-pane label="企业网银支付" name="second">
              <div style="margin: 20px 0">
                <el-radio v-model="companyRadio" label="1">
                  <img src="./img/银联.png" alt="" class="img1">
                </el-radio>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="code" v-show="ifPay">
          <img :src="codeUrl" alt="" style="width: 120px;height: 120px">
        </div>
        <div style="text-align: end">
          <button @click="btnClick" v-show="isPay">确认支付</button>
          <button @click="btnPay" v-show="yesPay">我已支付</button>
        </div>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="20%"

        >
          <span style="font-size: 18px">已成功支付，点击确定关闭页面</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="skip">确定</el-button>
          </span>
        </el-dialog>
      </div>
      <div style="background-color: rgb(218,241,248);margin: 20px 0;padding: 10px;width: 1140px" v-if="orderList.upgrade === false">
        <div class="text_end">温馨提示:</div>
        <div class="text_end">
          1. 您当前通过“{{ payType }}支付”，基于“{{  orderList.preRole}}”续费“{{  orderList.buyItem }}”（1个月统一按照31天计算）;
        </div>
        <div class="text_end">2. 当前“{{  orderList.preRole}}”剩余的使用天数为{{ orderList.originDuration }}天，续费{{ orderList.presentDuration-orderList.originDuration  }}天，合计使用天数为{{ orderList.presentDuration }}天；</div>
        <div class="text_end">3. “会员帐户”一但升级，将保留为升级后的会员帐户版本，不能降回原来的帐户版本。</div>
      </div>
      <div style="background-color: rgb(218,241,248);margin: 20px 0px;padding: 10px;" v-else>
        <div class="text_end">温馨提示:</div>
        <div class="text_end">
          1. 您当前通过“{{ payType }}支付”，基于“{{  orderList.preRole}}”升级为“{{  orderList.buyItem }}”（1个月统一按照31天计算）;
        </div>
        <div class="text_end">2. 当前“{{  orderList.preRole}}”剩余的使用天数为{{ orderList.originDuration }}天，统一按照20%折算，{{ orderList.calculateDuration }}天使用天数将叠加到“{{  orderList.buyItem }}”，合计使用天数为{{ orderList.presentDuration }}天；</div>
        <div class="text_end">3. “会员帐户”一但升级，将保留为升级后的会员帐户版本，不能降回原来的帐户版本。</div>
      </div>
    </div>
  </div>
</template>

<script>
  import top from "@/components/content/top";
  import 'common/Format';
  import {request} from "@/network/request";

  export default {
    name: "payView",
    components:{
      'top': top,
    },
    data(){
      return{
        activeData:1,
        stepOptions:[
        {
          title:'确认订单'
        },
        {
          title:'支付'
        },
        {
          title:'支付成功'
        },
        

      ],
        activeName: 'first',
        personalRadio: '1',
        companyRadio: '1',
        //是否确认支付
        ifPay:false,
        //小窗口
        dialogVisible:false,
        //token
        token: '',
        //base64
        codeUrl: '',
        //订单数据
        orderList:'',
        timer: null,
        isPay:true,
        yesPay:false,
        // 是支付宝支付
        isAliPay:false,
        // 默认支付方式
        payType:'个人网银'
      }
    },
    methods:{
      btnClick(){
        // console.log(this.personalRadio)
        if(this.activeName == 'first' && this.personalRadio == 3){
          request({
            url:'/user/pay/wechat/generateQrCode',
            method:'post',
            header: {
              'Content-Type': 'application/json'
            },
            data: {
              "param": this.token
            }
          }).then(res => {
            if(res.data.code === 1){
              this.codeUrl = 'data:image/png;base64,' + res.data.info
              this.ifPay = true
              this.isPay = false
              this.yesPay = true
              this.timer = setInterval(this.getIsPay,2000)
            }else if(res.data.code === 1001){
              this.$message.error('订单已过期')
              this.$router.replace('/userInfo')
            }
          })
        }else if(this.activeName == 'first' && this.personalRadio == 1){
          // window.location.href='/api/user/pay/chinaPay/generateB2cForm?token=' + this.token
          this.isPay = false
          this.yesPay = true
          this.timer = setInterval(this.getIsPay,2000)
          this.isAliPay = true
          window.open('/api/user/pay/chinaPay/generateB2cForm?token=' + this.token)
          // this.timer = setInterval(this.getIsPay,2000)
        }else if(this.activeName == 'first' && this.personalRadio == 2){
          // this.$message.success('敬请期待')
          this.isPay = false
          this.yesPay = true
          this.timer = setInterval(this.getIsPay,2000)
          this.isAliPay = true
          // window.location.href='/api/user/pay/aliPay/generateForm?token=' + this.token
          window.open('/api/user/pay/aliPay/generateForm?token=' + this.token)

        }else if(this.activeName == 'second' && this.companyRadio == 1){
          this.isPay = false
          this.yesPay = true
          this.timer = setInterval(this.getIsPay,2000)
          this.isAliPay = true
          // window.location.href='/api/user/pay/chinaPay/generateB2bForm?token=' + this.token
          window.open('/api/user/pay/chinaPay/generateB2bForm?token=' + this.token)
        }


      },
      //取得订单数据
      getOrder(){

        this.orderList = this.$route.query
        this.token = this.$route.query.token
        if(this.$route.query.activeName){
          this.activeName = this.$route.query.activeName

        }else{
          this.activeName = 'first'
        }

        // this.orderList = this.$route.params.orderList
        // this.token = this.$route.params.token
        // console.log(this.orderList)
      },
      getIsPay(){
        request({
          url:'/user/pay/getOrderState',
          method:'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "param": this.token
          }
        }).then(res => {
          if(res.data.code === 1){
            // console.log(res.data.info)
            if(res.data.info === "SUCCESS"){
              clearInterval(this.timer);
              this.$message.success("支付成功")
              this.dialogVisible = true
              // if(this.isAliPay === true){
              //
              // }else{
              //   // setTimeout(()=>this.$router.go(-1),500)
              //   setTimeout(()=>window.close(),2000)
              // }
            }
          }
        })
      },
      btnPay(){
        if(this.activeName == 'first' && this.personalRadio == 3){
          request({
            url:'/user/pay/wechat/iHasPaid',
            method:'post',
            header: {
              'Content-Type': 'application/json'
            },
            data: {
              "param": this.token
            }
          })
        }else if(this.activeName == 'first' && this.personalRadio == 2){
          request({
            url:'/user/pay/aliPay/iHasPaid',
            method:'post',
            header: {
              'Content-Type': 'application/json'
            },
            data: {
              "param": this.token
            }
          })
        }

      },
      skip(){
        // setTimeout(()=>this.$router.go(-1),500)
        this.$router.replace('userInfo')
        // setTimeout(()=>window.close(),500)

      },
      changeType(){
        if(this.activeName == 'first' && this.personalRadio == 1){
          this.ifPay = false
          this.payType = '个人网银'
        }else if(this.activeName == 'first' && this.personalRadio == 2){
          this.ifPay = false
          this.payType = '个人支付宝'
        }else if(this.activeName == 'first' && this.personalRadio == 3){
          if(this.codeUrl !== ''){
            this.ifPay = true
          }
          this.payType = '个人微信'
        }else if(this.activeName == 'second' && this.companyRadio == 1){
          this.ifPay = false
          this.payType = '企业网银'
        }
      }
    },
    created() {
      this.getOrder()
    },
    mounted() {

    },
    beforeDestroy() {

    }
  }
</script>

<style scoped>
  .module{
    width: 100%;
    min-width: 1600px;
    min-height: 100vh;
    height: 100%;
    background-color: #fff;
    /* background-color: #f1f4ff; */
  }

  .module_top{
    padding: 0 200px;
    background-color: #022028;
  }

  .main{
    margin: 0 auto;
    width: 70%;
  }

  .main .img{
    text-align: center;
  }

  .main .item{
    border: 1px solid #e6e6e6;
    padding: 10px 20px;
    /* width: 1140px; */
    margin: 0 auto  ;
  }

  .main .item .title{
    margin: 10px 0;
    font-size: 14px;
    font-weight: bold;
  }

  .t_header{
    background-color: #e6f3fb;
  }

  .t_header, .t_body{
    display: flex;
    text-align: center;
    border: 1px solid #19ACFD;
    border-right: none;
    border-bottom: none;
    height: 40px;
    line-height: 40px;
  }

  .t_body{
    border-bottom: 1px solid #19ACFD;
  }

  .t_header div, .t_body div{
    border-right: 1px solid #19ACFD;
  }

  .item1{
    flex: 2;
  }

  .item2{
    flex: 5;
  }

  .item3{
    flex: 1.5;
  }

  .detail{
    cursor: not-allowed;
  }

  .money{
    font-size: 16px;
    font-weight: bold;
    color: red;
  }

  .img1{
    width: 120px;
    height: 30px;
  }

  .img2{
    height: 30px;
    width: 90px;
  }

  .img3{
    width: 110px;
    height: 30px;
  }

  button{
    padding: 10px 50px;
    outline: none;
    border: none;
    background-color: #00a0c7;
    /* border-radius: 5px; */
    cursor: pointer;
    margin-top: 50px;
    color: white;
  }

  button:hover{
    opacity: .8;
  }

  .code{
    width: 120px;
    height: 120px;
    background-color: red;
    text-align: center;
    margin: 0 auto;
  }
  .text_end{
    font-size: 12px;
    color: rgb(228,71,36);
    font-weight: bolder;
    margin: 5px 0;
  }
  
</style>
<style lang="scss">

.tabs-item {
  .el-tabs--bottom .el-tabs__item.is-bottom:last-child, .el-tabs--bottom .el-tabs__item.is-top:last-child, .el-tabs--top .el-tabs__item.is-bottom:last-child, .el-tabs--top .el-tabs__item.is-top:last-child{
    font-weight: bold;
  }
}

.tabs-item {
  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2){
    font-weight: bold;
  }
}

</style>

<style scoped lang="scss">
.abu{
  // position: absolute;
  // z-index: 2;
  // background-color: #a8a8a8;
}
.next-step-arrow {
    // display: -ms-flexbox;
    display: flex;
}
.next-step-horizontal {
    overflow: hidden;
}
.next-step {
    width: 100%;
    position: relative;
    border: none;
}
.next-step-arrow .next-step-item-first:before {
  background-color: inherit;
    border: 16px solid transparent;
}
.next-step.next-step-arrow>.next-step-item-process {
    background: #00a0c7;
}
.next-step-arrow .next-step-item-first {
    margin-left: 0;
}
.next-step-arrow .next-step-item {
    -ms-flex: 1;
    flex: 1;
    height: 32px;
    line-height: 32px;
    margin-left: 16px;
    margin-right: 4px;
    background-color: #99dcf3;
}
.next-step-horizontal>.next-step-item {
    display: inline-block;
    text-align: left;
}
.next-step-item {
    position: relative;
    vertical-align: middle;
    outline: 0;
    height: 100%;
}
li, ul {
    list-style: none;
    padding: 0;
}
.next-step.next-step-arrow>.next-step-item-process:before {
    border-color: #00a0c7;
    border-left-color: transparent;
}


.next-step-arrow .next-step-item .next-step-item-container {
    min-width: 100px;
    height: 32px;
    cursor: pointer;
}
.next-step.next-step-arrow>.next-step-item-process:after {
    border-left-color: #00a0c7;
}
.next-step-arrow .next-step-item:after {
    content: "";
    position: absolute;
    right: -16px;
    top: 0;
    z-index: 1;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-left: 16px solid transparent;
}
.next-step-arrow .next-step-item .next-step-item-container {
    min-width: 100px;
    height: 32px;
    cursor: pointer;
}
.next-step.next-step-arrow>.next-step-item-wait:before {
    border-color: #99dcf3;
    border-left-color: transparent;
}
.next-step-arrow>.next-step-item-wait:before {
    border: 16px solid #ebecf0;
    border-left-color: transparent;
}
.next-step-arrow .next-step-item:before {
    content: "";
    position: absolute;
    left: -16px;
    top: 0;
    z-index: 1;
    border: 16px solid transparent;
    border-left-color: transparent;
}
.next-step.next-step-arrow>.next-step-item-wait:after {
    border-left-color: #99dcf3;
}
.next-step.next-step-arrow>.next-step-item-wait:after {
    border-left-color: #99dcf3;
}
.next-step-arrow>.next-step-item-wait:after {
    border-left-color: #ebecf0;
}
.next-step-arrow .next-step-item:after {
    content: "";
    position: absolute;
    right: -16px;
    top: 0;
    z-index: 1;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-left: 16px solid transparent;
}
.next-step-arrow .next-step-item .next-step-item-container .next-step-item-title {
    height: 32px;
    line-height: 32px;
    // font-weight: 700;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}
.next-step-arrow>.next-step-item-process .next-step-item-title {
    color: #fff;
    word-break: break-word;
}
.next-step-arrow>.next-step-item-wait .next-step-item-title {
    // color: #999;
    color: #fff;
    word-break: break-word;
}
.next-step.next-step-arrow>.next-step-item-wait {
    background: #99dcf3;
}
.next-step.next-step-arrow>.next-step-item-wait:after {
    border-left-color: #99dcf3;
}
.next-step-arrow .next-step-item-last:after {
    border: 16px solid transparent;
}
</style>
